/* eslint-disable @stylistic/max-len */
import React from 'react';
import propTypes from './propTypes';

const Pea = ({ className = 'icon', notUseClass = false, style = {} }) => (
  <svg
    className={notUseClass ? '' : className}
    style={{ color: '#696f88', ...style }}
    width="13"
    height="18"
    fill="none"
    viewBox="0 0 13 18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8.07603 17.3664C7.55043 17.3664 7.03922 17.2344 6.62642 16.992C7.50963 14.7336 8.12403 12.9312 8.56083 11.328C9.06723 9.46798 9.35283 7.78799 9.43203 6.19199C9.44643 5.87999 9.45363 5.57759 9.46323 5.28239C9.50403 3.82559 9.54003 2.568 10.1376 1.5336L10.14 1.5312C10.4088 1.0344 10.8672 0.559199 11.616 0L11.784 0.168C11.3304 0.842399 11.268 1.296 11.316 1.7976C11.3496 2.1888 11.5152 2.6472 11.724 3.22559C12.0792 4.20719 12.564 5.55119 12.7344 7.50719C12.8424 8.74558 12.8136 9.96718 12.648 11.1384C12.4872 12.2832 12.204 13.3272 11.808 14.2368C10.9848 16.1256 9.76083 17.232 8.35923 17.3544C8.26563 17.364 8.17203 17.3664 8.07603 17.3664ZM1.2192 15.2064C0.741603 15.2064 0.302401 15.108 0 14.9304C1.71601 10.9392 2.48401 8.25599 2.65201 5.68799C2.67121 5.40959 2.68321 5.13839 2.69521 4.87439C2.75281 3.64559 2.80321 2.5824 3.36241 1.704C3.62401 1.2792 4.08241 0.895198 4.77842 0.383999L4.93202 0.513599C4.56002 1.02 4.42562 1.428 4.47122 1.8984C4.50002 2.2368 4.65362 2.6256 4.85042 3.11759C5.18402 3.95039 5.63762 5.08799 5.78402 6.77039C5.87522 7.81919 5.83682 8.85838 5.66882 9.85678C5.50562 10.8336 5.22482 11.7216 4.83842 12.5016C4.03441 14.1192 2.85121 15.0744 1.50481 15.1944C1.4112 15.2016 1.3152 15.2064 1.2192 15.2064Z" fill="currentColor" />
  </svg>
);

Pea.propTypes = propTypes;

export default Pea;
